import { RecommendationCard } from "./RecommendationCard";
import { MatchingFallback } from "./MatchingFallback";
import type { MatchingResponse } from "./types";

interface Props {
  result: MatchingResponse;
  onRestart: () => void;
}

export function MatchingResults({ result, onRestart }: Props) {
  const fallbackRecommendations = result.fallbackRecommendations ?? [];

  return (
    <div className="mx-auto flex max-w-5xl flex-col gap-6 px-4 py-8 sm:py-10">
      <div className="flex flex-col gap-2">
        <p className="font-mono text-xs uppercase tracking-widest text-primary">Preporuke</p>
        <h1 className="text-3xl font-semibold text-foreground sm:text-4xl" style={{ fontFamily: "var(--font-heading)" }}>
          {result.recommendations.length > 0
            ? "Terapeuti koji najbolje odgovaraju vašim odgovorima"
            : "Najbliže dostupne opcije"}
        </h1>
        <p className="max-w-2xl text-sm text-muted-foreground">
          {result.recommendations.length > 0
            ? "Prikazujemo samo terapeute koji primaju nove klijente, podržavaju odabrani jezik i imaju slobodan termin."
            : "Nismo pronašli potpuno podudaranje sa svim kriterijima, ali možete pregledati terapeute koji su najbliži vašem upitu."}
        </p>
      </div>

      {result.recommendations.length > 0 ? (
        <div className="grid gap-4 lg:grid-cols-2">
          {result.recommendations.map((recommendation) => (
            <RecommendationCard key={recommendation.therapist.id} recommendation={recommendation} token={result.token} />
          ))}
        </div>
      ) : null}

      {fallbackRecommendations.length > 0 ? (
        <section className="rounded-xl border bg-card p-5 shadow-sm">
          <div className="flex flex-col gap-1">
            <p className="font-mono text-xs uppercase tracking-widest text-primary">Bliske opcije</p>
            <h2 className="text-xl font-semibold text-foreground" style={{ fontFamily: "var(--font-heading)" }}>
              Terapeuti koje vrijedi razmotriti
            </h2>
            <p className="max-w-2xl text-sm text-muted-foreground">
              Ove opcije nisu potpuno podudaranje, ali su dostupne i najbliže su vašim odgovorima.
              {result.fallback?.relaxed?.includes("language") ? " Proširili smo kriterij jezika." : ""}
              {result.fallback?.relaxed?.includes("modality") ? " Proširili smo format susreta." : ""}
            </p>
          </div>
          <div className="mt-4 grid gap-4 lg:grid-cols-2">
            {fallbackRecommendations.map((recommendation) => (
              <RecommendationCard key={recommendation.therapist.id} recommendation={recommendation} token={result.token} />
            ))}
          </div>
        </section>
      ) : null}

      {result.fallback && <MatchingFallback fallback={result.fallback} onRestart={onRestart} />}
    </div>
  );
}
